import { render } from "./DonationTypeTabs.vue?vue&type=template&id=4fe2332c&scoped=true"
import script from "./DonationTypeTabs.vue?vue&type=script&lang=js"
export * from "./DonationTypeTabs.vue?vue&type=script&lang=js"

import "./DonationTypeTabs.vue?vue&type=style&index=0&id=4fe2332c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe2332c"]])

export default __exports__